// extracted by mini-css-extract-plugin
export default {"toolbar":"FormattingToolbar_toolbar__f9VUP"};